"use client";

import { scrollToTop } from "@homeinstead/shared";
import { Link } from "~care/components/ui/Link/Link";

export default function ShallowBenefitsButton({
  buttonText,
}: {
  buttonText: string;
}) {
  return (
    <Link
      className="inline-flex self-start"
      href={"#"}
      onClick={(e) => {
        e.preventDefault();
        scrollToTop();
      }}
      variant="secondary"
    >
      {buttonText}
    </Link>
  );
}
